import React, { ReactElement } from "react"
import {
	Timeline,
	TimelineConnector,
	TimelineContent,
	TimelineDot,
	TimelineItem,
	timelineItemClasses,
	TimelineSeparator,
} from "@mui/lab"
import { ActionUtils } from "models"
import Icon from "@mdi/react"
import {
	Box,
	Typography,
} from "@mui/material"
import { Trans } from "@lingui/macro"
import {
	MatchActionType,
	MatchTimeline,
} from "components/match-proposal/model"
import {
	mdiCalendarMonth,
	mdiCheckCircleOutline,
	mdiClipboardTextSearch,
	mdiEmail,
	mdiEmailFast,
	mdiEye,
	mdiFileDocument,
	mdiPhone,
	mdiPhoneIncoming,
	mdiPlusCircleOutline,
	mdiShaker,
	mdiSwapHorizontal,
} from "@mdi/js"
import { i18n } from "@lingui/core"
import { MatchService } from "services/match.service"
import { MatesComponent, MatesComponentState } from "components/mates-component"
import withUseRouter, { UseRouterParams } from "services/router"
import { ErrorResponse, Loading, RestResponse } from "@sinossi/mates-react-library"
import { DateTime } from "luxon"

interface MatchProposalDetailsTimelineProps extends UseRouterParams {
	timelineId: string
}

interface MatchProposalDetailsTimelineState extends MatesComponentState {
	loading: boolean
	timelineData: []
}

class MatchProposalDetailsTimeline extends React.Component<MatchProposalDetailsTimelineProps, MatchProposalDetailsTimelineState> {

	private readonly matesComponent: MatesComponent<UseRouterParams, MatchProposalDetailsTimelineState> = new MatesComponent<UseRouterParams, MatchProposalDetailsTimelineState>(this)

	constructor(props: MatchProposalDetailsTimelineProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: true,
			timelineData: []
		}
	}

	componentDidMount(): void {
		this.fetchTimelineData()
	}

	private fetchTimelineData = () => {
		MatchService.getTimelineData(this.props.timelineId, this.fetchTimelineDataCallback, this.matesComponent.onError)
	}

	private fetchTimelineDataCallback = (resp: RestResponse<any, ErrorResponse>) => {
		this.setState(() => ({
			timelineData: resp.data,
			loading: false
		}))
	}

	private getIcon = (actionType: MatchActionType): ReactElement => {
		switch (actionType) {
			case MatchActionType.CALL:
				return <Icon path={mdiPhone} size={1} />
			case MatchActionType.CHANGE_STATUS:
				return <Icon path={mdiSwapHorizontal} size={1} />
			case MatchActionType.SENT:
				return <Icon path={mdiEmailFast} size={1} />
			case MatchActionType.VISIT:
				return <Icon path={mdiCalendarMonth} size={1} />
			case MatchActionType.ACCEPTED:
				return <Icon path={mdiCheckCircleOutline} size={1} />
			case MatchActionType.VISIBILITY_CHANGED:
				return <Icon path={mdiEye} size={1} />
			case MatchActionType.EMAIL:
				return <Icon path={mdiEmail} size={1} />
			case MatchActionType.PHONE_CALL:
				return <Icon path={mdiPhoneIncoming} size={1} />
			case MatchActionType.LETTER:
				return <Icon path={mdiFileDocument} size={1} />
			case MatchActionType.SURVEY:
				return <Icon path={mdiClipboardTextSearch} size={1} />
			case MatchActionType.CREATION:
				return <Icon path={mdiPlusCircleOutline} size={1} />
		}
	}

	private getTitle = (item: MatchTimeline) => {
		let title = ""

		switch (item.type) {
			case MatchActionType.CALL:
				//title = `Telefonata per ${i18n._(item.reason)}`
				break
			case MatchActionType.CHANGE_STATUS:
				title = `Cambio stato da ${i18n._(`enums.asset-matches-brand-status.${item.oldStatus}`)} a ${i18n._(`enums.asset-matches-brand-status.${item.newStatus}`)}`
				break
			case MatchActionType.SENT:
			case MatchActionType.EMAIL:
				title = `Proposta inviata via email`
				break
			case MatchActionType.VISIT:
				//title = `Sopralluogo programmato per ${DateTime.fromISO(item.visitDate).toFormat("dd/MM/yyyy")}`
				break;
			case MatchActionType.PHONE_CALL:
				title = `Chiamata telefonica`
				break
			case MatchActionType.LETTER:
				title = `Lettera inviata`
				break
			case MatchActionType.SURVEY:
				title = `Questionario compilato`
				break
			case MatchActionType.CREATION:
				title = `Proposta creata`
				break
			case MatchActionType.ACCEPTED:
				title = `Proposta accettata`
				break
			case MatchActionType.VISIBILITY_CHANGED:
				title = `Reso visibile al brand`
				break
			default:
				title = `Azione: ${item.type}`
				break
		}
		return (
			<Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
				{title}
			</Typography>
		)
	}

	render() {
		return (
			this.state.loading ?
			<Loading show/> : 
			<Timeline
				sx={{
					[`& .${timelineItemClasses.root}:before`]: {
						flex: 0,
						padding: 0,
					},
				}}
			>
				{
					(this.state.timelineData.map((item: MatchTimeline, index) => (
						<TimelineItem key={index}>
							<TimelineSeparator>
								<TimelineDot>
									{this.getIcon(item.type)}
								</TimelineDot>
								{
									index < this.state.timelineData.length - 1 &&
									<TimelineConnector />
								}
							</TimelineSeparator>
							<TimelineContent>
								{this.getTitle(item)}
								<Box sx={{ p: 2, pt: 1, pl: 0 }}>
									<Typography sx={{ fontSize: 13 }}>
										<Trans id={"mpdt.executed"}>
											Eseguito il {DateTime.fromISO(item.creationDate).toFormat("dd/MM/yyyy")}
										</Trans>
									</Typography>

									<Typography sx={{ fontSize: 13 }} display={"inline-block"}>
										<Trans id={"mpdt.executed-by"}>
											Gestito da {
											item.creator?.accountDetails?.firstName && item.creator?.accountDetails?.lastName ? 
											item.creator.accountDetails.firstName + " " + item.creator.accountDetails.lastName : "/"}
										</Trans>
									</Typography>
								</Box>
							</TimelineContent>
						</TimelineItem>
					)))
				}
			</Timeline>
		)
	}
}

export default withUseRouter(MatchProposalDetailsTimeline)